import React from 'react';

import { Icon } from '@column/column-ui-kit';

import { TransferEntryType } from '~/repositories';

export enum TransferDirection {
  Incoming = 'Incoming',
  Outgoing = 'Outgoing',
  Internal = 'Internal',
}

export const getTransferDirection = (transferType: TransferEntryType, isIncoming: boolean): TransferDirection => {
  switch (transferType) {
    case 'book':
      return TransferDirection.Internal;
    case 'check_credit':
      return TransferDirection.Incoming;
    case 'check_debit':
      return TransferDirection.Outgoing;
    default:
      return isIncoming ? TransferDirection.Incoming : TransferDirection.Outgoing;
  }
};

export const getTransferDirectionLabel = (transferType: TransferEntryType, isIncoming: boolean): string => {
  if (transferType === 'check_credit') {
    return 'Deposit';
  }
  if (transferType === 'check_debit') {
    return 'Issue';
  }
  return getTransferDirection(transferType, isIncoming);
};

export const getTransferDirectionIcon = (transferType: TransferEntryType, isIncoming: boolean) => {
  const direction = getTransferDirection(transferType, isIncoming);
  switch (direction) {
    case TransferDirection.Incoming:
      return <Icon.CircleArrowDown />;
    case TransferDirection.Outgoing:
      return <Icon.CircleArrowUp />;
    case TransferDirection.Internal:
      return <Icon.Swap />;
  }
};
